<template>
    <div>
        <b-spinner variant="primary"
            class="spinStyle"
            v-show="showSpin"
            label="Text Centered"></b-spinner>
        <b-row v-if="!showSpin"
            style="margin-top:10px;">
            <b-col lg="12">
                <div class="filterBar">
                    <b-row>
                        <b-col lg="2">
                            <b-form-select v-model="selectedYear"
                                size="sm"
                                @change="onYearSelectChange">
                                <option :value="0">选择年份</option>
                                <option value="2019">2019年</option>
                                <option value="2020">2020年</option>
                            </b-form-select>
                        </b-col>
                        <b-col lg="2">
                            <b-form-select v-model="selectedMonth"
                                size="sm"
                                @change="onMonthSelectChange">
                                <option :value="0">选择月份</option>
                                <option :value="item"
                                    v-for="item in monthList"
                                    :key="item">
                                    {{item}}月
                                </option>
                            </b-form-select>
                        </b-col>
                        <b-col lg="4">
                            <b-form-select v-model="selectedWeek"
                                size="sm"
                                @change="onWeekSelectChange">
                                <option :value="0">选择周数</option>
                                <option :value="item.weekSeq"
                                    v-for="item in weekList"
                                    :key="item.weekUuid">
                                    第{{item.weekSeq}}周 {{item.weekBeginDate}}到{{item.weekEndDate}}
                                </option>
                            </b-form-select>
                        </b-col>
                    </b-row>
                    <b-row style="margin-top:10px;">
                        <b-col lg="3">
                            <b-input-group>
                                <b-form-input size="sm"
                                    v-model="productSearchValue"
                                    placeholder="输入品名"></b-form-input>
                                <b-input-group-append>
                                    <b-button size="sm"
                                        v-on:click="searchProductByName()">查询</b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                        <b-col lg="7">
                            <b-button size="sm"
                                variant="info"
                                v-on:click="onShowMultiCateSelect()">分类选择 <b-badge variant="info">{{selectedMultiCateList.length}}</b-badge>
                            </b-button>
                            <b-button size="sm"
                                variant="warning"
                                style="margin-left:10px"
                                v-on:click="onShowMultiBrandSelect()">品牌选择 <b-badge variant="warning">{{selectedMultiBrandList.length}}</b-badge>
                            </b-button>
                             <b-button size="sm"
                                variant="success"
                                style="margin-left:10px"
                                v-on:click="onShowMyfavorite()">我的收藏 <b-badge variant="success">{{myfavoriteList.length}}</b-badge>
                            </b-button>
                            <b-button size="sm"
                                style="margin-left:10px"
                                v-on:click="goToCart()">预售购物车 <b-badge>{{cartItems.length}}</b-badge>
                            </b-button>
                            <b-button size="sm"
                                style="margin-left:10px"
                                variant="primary"
                                :to="{name: 'FastBooking'}">快速预订
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
                <div class="dataTable">
                    <b-table id="product-table"
                        :fields="productFields"
                        :items="prodcutItems"
                        small
                        bordered
                        hover
                        :busy="isTableBusy">
                        <template slot="productImg"
                            slot-scope="row">
                            <b-link :to="{path: '/product/product-detail', query: { productUuid: row.item.productUuid }}"
                                target="_blank">
                                <img :src="row.item.productFinishImageFile.url"
                                    width="30"
                                    height="30">
                            </b-link>
                        </template>
                        <template slot="orderQuantity"
                            slot-scope="row">
                            <b-form-input size="sm"
                                v-model="row.item.orderQuantity">
                            </b-form-input>
                        </template>
                        <template slot="orderButton"
                            slot-scope="row">
                            <a href="#"
                                v-on:click="addOrDelToFavorite(row)">{{myfavoriteList.includes(row.item.productUuid) ? '取消收藏' : '添加收藏'}}</a> /
                            <a href="#"
                                v-on:click="addToCart(row)">订购</a>
                        </template>
                        <div slot="table-busy"
                            class="text-center text-info my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>加载中...</strong>
                        </div>
                    </b-table>
                </div>
                <div class="pageControl">
                    <b-pagination v-model="feSearch.limit.conditions.pageStart"
                        style="margin-top:20px;"
                        :total-rows="feSearch.limit.conditions.total"
                        :per-page="feSearch.limit.conditions.pageLength"
                        align="center"
                        size="sm"
                        ellipsis-text="..."
                        first-text="首页"
                        prev-text="上一页"
                        next-text="下一页"
                        last-text="尾页"
                        limit="10"
                        @change="onPageChange"></b-pagination>
                </div>
            </b-col>
        </b-row>
        <b-modal id="multiCateSelectModel"
            v-model="multiCateSelectModel.show"
            :title="multiCateSelectModel.title"
            size="xl">
            <b-row align-v="center">
                <b-col lg="12">
                    <b-tabs content-class="mt-3">
                        <b-tab :title="item.mainCategoryName"
                            v-for="item in mainCateList"
                            :key="item.mainCategoryUuid"
                            @click='loadSubCate(item.mainCategoryUuid)'>
                            <b-row>
                                <b-col lg="1"
                                    v-for="item in filterSubCateList"
                                    :key="item.subCategoryUuid">
                                    <b-card overlay
                                        :img-src="item.subCategoryFile.url"
                                        :img-alt="item.subCategoryName"
                                        img-top
                                        style="margin-top:10px;"
                                        v-bind:class="{ selectcateborder : selectedMultiCateList.includes(item.subCategoryUuid)}"
                                        v-on:click="onSelectMultiCate(item.subCategoryUuid)">
                                    </b-card>
                                    <b-card-text style="font-size:10px;text-align:center;">
                                        {{item.subCategoryName}}
                                    </b-card-text>
                                </b-col>
                            </b-row>
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>

            <template slot="modal-footer">
                <b-button size="sm"
                    variant="success"
                    @click="confirmMultiCateSearch()">
                    确认
                </b-button>
                <b-button size="sm"
                    variant="danger"
                    @click="multiCateSelectModel.show = false">
                    取消
                </b-button>
            </template>
        </b-modal>
        <b-modal id="multiBrandSelectModel"
            v-model="multiBrandSelectModel.show"
            :title="multiBrandSelectModel.title"
            size="xl">
            <b-row align-v="center">
                <b-col lg="1"
                    v-for="item in filterBrandList"
                    :key="item.brandUuid">
                    <b-card overlay
                        :img-src="item.brandMainImageFile.url"
                        :img-alt="item.brandName"
                        img-top
                        style="margin-top:10px;"
                        v-bind:class="{ selectcateborder : selectedMultiBrandList.includes(item.brandUuid)}"
                        v-on:click="onSelectMultiBrand(item.brandUuid)">
                    </b-card>
                    <b-card-text style="font-size:10px;text-align:center;">
                        {{item.brandName}}
                    </b-card-text>
                </b-col>
            </b-row>

            <template slot="modal-footer">
                <b-button size="sm"
                    variant="success"
                    @click="confirmMultiBrandSearch()">
                    确认
                </b-button>
                <b-button size="sm"
                    variant="danger"
                    @click="multiBrandSelectModel.show = false">
                    取消
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import api from '@/api/api';
import search from '@/libs/search';
import "@/style/global.css";
export default {
    name: 'BookingList',
    data() {
        return {
            showSpin: false,
            isTableBusy: false,
            loadingInterval: 300,
            productFields: [
                { key: 'productImg', label: '缩图' },
                { key: 'productCode', label: '编码' },
                { key: 'productName', label: '品名' },
                { key: 'productSpec', label: '规格' },
                { key: 'brandName', label: '品牌' },
                { key: 'unitName', label: '单位' },
                { key: 'packagePrice', label: '纸箱费' },
                { key: 'packageQuantity', label: '装箱量' },
                { key: 'weekKnownText', label: '预售周次' },
                { key: 'preSalePlanPrice', label: '单价' },
                { key: 'productMinPurchaseLimit', label: '最少订购量' },
                { key: 'preSalePlanOfferAmount', label: '可预售量' },
                { key: 'orderQuantity', label: '订购数量' },
                { key: 'orderButton', label: '操作' }
            ],
            prodcutItems: [],
            cartItems: [],
            feSearch: search.getSearchParams(),
            mainCateList: [],
            subCateList: [],
            filterSubCateList: [],
            brandList: [],
            filterBrandList: [],
            productSearchValue: '',

            allWeeks: [],
            selectedYear: 0,
            yearList: [2019, 2020],
            selectedMonth: 0,
            monthList: [],
            selectedWeek: 0,
            weekList: [],

            selectedMultiCateList: [],
            multiCateSelectModel: {
                show: false,
                title: '分类选择'
            },

            isNeedUpdateBrand: false,
            selectedMultiBrandList: [],
            multiBrandSelectModel: {
                show: false,
                title: '品牌选择'
            },

            myfavoriteList: []
        };
    },
    mounted() {
        if (!this.checkMemberLogin()) {
            this.$router.push({
                name: 'MemberLogin'
            });
            return;
        };
        this.feSearch.filters.enable = true;
        //从商品详细页的跳转
        if(this.$route.query.productName){
            this.feSearch.isFav = false;
            this.productSearchValue = this.$route.query.productName;
            search.globalRemoveFilterConditionKey(this.feSearch, 'productName');
            this.feSearch.filters.conditions.push({
                name: 'productName',
                type: 'eq',
                value: this.productSearchValue
            });
        }

        this.getBookingCartList();
        this.getSalesPageData();
        this.setInitialWeekData();
        this.getMyFavorite();
    },
    methods: {
        onShowMultiCateSelect() {
            this.multiCateSelectModel.show = true;
            this.loadSubCate(this.mainCateList[0].mainCategoryUuid);
        },
        loadSubCate(mainCateUuid) {
            this.filterSubCateList = this.subCateList.filter(e => {
                return e.subCategoryMainUuid === mainCateUuid;
            });
        },
        onSelectMultiCate(cateUuid) {
            let index = this.selectedMultiCateList.indexOf(cateUuid);
            if (index === -1) {
                this.selectedMultiCateList.push(cateUuid);
            }
            else {
                this.selectedMultiCateList.splice(index, 1);
            }
        },
        confirmMultiCateSearch() {
            this.feSearch.isFav = false;
            search.globalRemoveFilterConditionKey(this.feSearch, 'productSubCategoryUuid');
            search.globalResetSearch(this.feSearch); //返回第一页
            if (this.selectedMultiCateList.length > 0) {
                this.feSearch.filters.conditions.push({
                    name: 'productSubCategoryUuid',
                    type: 'in',
                    value: JSON.stringify(this.selectedMultiCateList)
                });
            }
            this.isNeedUpdateBrand = true;
            //清除品牌选择信息
            search.globalRemoveFilterConditionKey(this.feSearch, 'productBrandUuid');
            this.selectedMultiBrandList = [];
            this.getProductList();
            this.multiCateSelectModel.show = false;
        },
        onShowMultiBrandSelect() {
            this.multiBrandSelectModel.show = true;
        },
        onSelectMultiBrand(brandUuid) {
            let index = this.selectedMultiBrandList.indexOf(brandUuid);
            if (index === -1) {
                this.selectedMultiBrandList.push(brandUuid);
            }
            else {
                this.selectedMultiBrandList.splice(index, 1);
            }
        },
        confirmMultiBrandSearch() {
            this.feSearch.isFav = false;
            search.globalRemoveFilterConditionKey(this.feSearch, 'productBrandUuid');
            search.globalResetSearch(this.feSearch); //返回第一页
            if (this.selectedMultiBrandList.length > 0) {
                this.feSearch.filters.conditions.push({
                    name: 'productBrandUuid',
                    type: 'in',
                    value: JSON.stringify(this.selectedMultiBrandList)
                });
            }
            this.getProductList();
            this.multiBrandSelectModel.show = false;
        },
        addOrDelToFavorite(row) {
            let data = {
                productUuid: row.item.productUuid
            };
            if (this.myfavoriteList.includes(row.item.productUuid)) {
                api.webDelProductFav(data).then(res => {
                    if (res.data.code === 0) {
                        this.getMyFavorite();
                    }
                });
            }
            else {
                api.webAddProductFav(data).then(res => {
                    if (res.data.code === 0) {
                        this.getMyFavorite();
                    }
                });
            }
        },
        onShowMyfavorite() {
            this.feSearch.isFav = true;
            search.globalRemoveFilterConditionKey(this.feSearch, 'productSubCategoryUuid');
            search.globalRemoveFilterConditionKey(this.feSearch, 'productBrandUuid');
            search.globalRemoveFilterConditionKey(this.feSearch, 'productName');
            this.feSearch.token = this.getLoginCookieLoginToken();
            this.getProductList();
        },
        getMyFavorite() {
            // let data = {
            //     token: this.getLoginCookieLoginToken()
            // };
            // api.webGetMyFavProducts(data).then(res => {
            //     this.myfavoriteList = res.data.data.products;
            // });
        },
        arrDistict(arr) {
            let hash = [];
            for (let i = 0; i < arr.length; i++) {
                if (hash.indexOf(arr[i]) == -1) {
                    hash.push(arr[i]);
                }
            }
            return hash;
        },
        getNowString() {
            let now = new Date();
            let year = now.getFullYear();
            let month = now.getMonth() + 1;
            if (month < 10) {
                month = '0' + month;
            }
            let day = now.getDate();
            if (day < 10) {
                day = '0' + day;
            }
            return year + '-' + month + '-' + day;
        },
        setInitialWeekData() {
            this.selectedYear = 2019;
            api.webGetWeekConfig({ years: [this.selectedYear] }).then(res => {
                if (res.data.code === 0) {
                    this.allWeeks = res.data.data;
                    let nowString = this.getNowString();
                    this.monthList = this.allWeeks.filter(e => {
                        return e.weekYear === parseInt(this.selectedYear) && e.weekEndDate > nowString;
                    }).map(e => {
                        return e.weekMonth;
                    });
                    this.monthList = this.arrDistict(this.monthList);
                    this.selectedMonth = this.monthList[0];

                    this.weekList = this.allWeeks.filter(e => {
                        return e.weekYear === parseInt(this.selectedYear) && e.weekMonth === parseInt(this.selectedMonth) && e.weekEndDate > nowString;
                    });
                    this.selectedWeek = this.weekList[0].weekSeq;
                    this.getProductList();
                }
            });
        },
        onYearSelectChange(year) {
            api.webGetWeekConfig({ years: [this.selectedYear] }).then(res => {
                if (res.data.code === 0) {
                    this.allWeeks = res.data.data;
                    this.selectedMonth = 0;
                    this.selectedWeek = 0;
                    this.weekList = [];

                    let nowString = this.getNowString();
                    this.monthList = this.allWeeks.filter(e => {
                        return e.weekYear === parseInt(this.selectedYear) && e.weekEndDate > nowString;
                    }).map(e => {
                        return e.weekMonth;
                    });
                    this.monthList = this.arrDistict(this.monthList);
                }
            });
        },
        onMonthSelectChange(month) {
            this.selectedWeek = 0;
            this.weekList = this.allWeeks.filter(e => {
                return e.weekYear === parseInt(this.selectedYear) && e.weekMonth === parseInt(this.selectedMonth);
            });
        },
        onWeekSelectChange(week) {
            this.getProductList();
        },
        getSalesPageData() {
            api.getSalesPageData({}).then(res => {
                if (res.code === 0) {
                    this.mainCateList = res.data.mainCateList.data.records;
                    this.subCateList = res.data.subCateList.data.records;
                    this.subCateList.forEach(e => {
                        e.subCategoryFile = JSON.parse(e.subCategoryFile);
                        e.subCategoryFile.url = api.fileServer + e.subCategoryFile.url;
                    });
                    this.brandList = res.data.brandList.data.records;
                    this.brandList = res.data.brandList.data.records;
                    this.filterBrandList = res.data.brandList.data.records;
                    this.brandList.forEach(e => {
                        e.brandMainImageFile = JSON.parse(e.brandMainImageFile);
                        e.brandMainImageFile.url = api.fileServer + e.brandMainImageFile.url;
                    });
                }
            });
        },
        getBookingCartList() {
            this.cartItems = [];
            setTimeout(() => {
                api.webPreSaleGetMyCart().then(res => {
                    if (res.data.code === 0) {
                        this.cartItems = res.data.data.cartItems;
                    }
                });
            }, this.loadingInterval);
        },
        getProductList() {
            this.isTableBusy = true;
            setTimeout(() => {
                this.feSearch.year = parseInt(this.selectedYear);
                this.feSearch.weeks = [parseInt(this.selectedWeek)];
                api.webGetPreSaleProductList(this.feSearch).then(res => {
                    this.isTableBusy = false;
                    if (res.data.code === 0) {
                        this.prodcutItems = res.data.data.records;
                        this.prodcutItems.forEach(p => {
                            p.productFinishImageFile = JSON.parse(p.productFinishImageFile);
                            p.productFinishImageFile.url = api.fileServer + p.productFinishImageFile.url;
                            p.weekKnownText = p.plans[this.selectedWeek].weekKnownText;
                            p.preSalePlanPrice = p.plans[this.selectedWeek].preSalePlanPrice;
                            p.preSalePlanOfferAmount = p.plans[this.selectedWeek].preSalePlanOfferAmount;
                            p.preSalePlanUuid = p.plans[this.selectedWeek].preSalePlanUuid;
                        });
                        search.globalSetFilterRecordCount(this.feSearch, res.data.data.filterRecordCount);

                        if (this.isNeedUpdateBrand) {
                            this.isNeedUpdateBrand = false;

                            let brands = Object.keys(res.data.data.brands);
                            this.filterBrandList = this.brandList.filter(e => {
                                return brands.includes(e.brandUuid);
                            });
                        }
                    }
                });
            }, this.loadingInterval);
        },
        searchProductByName() {
            this.feSearch.isFav = false;
            search.globalRemoveFilterConditionKey(this.feSearch, 'productName');
            this.feSearch.filters.conditions.push({
                name: 'productName',
                type: 'like',
                value: this.productSearchValue
            });
            this.getProductList();
        },
        //加入购物车
        addToCart(row) {
            let cartItems = [];
            cartItems.push({
                planUuid: row.item.preSalePlanUuid,
                orderQuantity: row.item.orderQuantity
            });
            api.webPreSaleAddToCart({ cartItems: cartItems }).then(res => {
                if (res.data.code === 0) {
                    this.$bvModal.msgBoxOk("订购成功", {
                        title: '提示',
                        buttonSize: 'sm'
                    });
                    this.getBookingCartList();
                }
            });
        },

        onPageChange(pageNum) {
            search.globalPageOnChange(this.feSearch, pageNum);
            this.getProductList();
        },
        goToCart() {
            let routeUrl = this.$router.resolve({
                path: '/member/cart-list',
                query: { tabIndex: 1 }
            });
            window.open(routeUrl.href, '_blank');
        }
    },
    components: {

    }
};
</script>

<style>
.orderButton {
    margin-top: 20px;
    text-align: right;
}
.table-bordered td,
.table-bordered th {
    vertical-align: middle;
}

.col-lg-2,
.col-lg-4,
.col-lg-5,
.col-lg-3,
.col-lg-7 {
    padding-right: 0;
}


.selectcateborder {
    border: solid 2px red !important;
}



 
 /* 表格 */
 .dataTable{margin-top:20px;}
 .dataTable th{background-color:#efefef;height:32px;line-height:32px;}
 
 .table thead th{vertical-align: bottom; border-bottom: 2px solid #dbdbdb;}
 
 .table-bordered td, .table-bordered th {border: 1px solid #dbdbdb;}
 .table-sm td, .table-sm th{padding:10px 5px;}
 /* 表格操作 */
 .table-sm td a{color:#00B151;}
 /* 页码 */
 .page-link{color:#757575 !important;}
 .page-link:hover{color: #00b151 !important;}
 .page-item.active .page-link{color:#fff !important;background-color: #28a745 !important;border-color: #28a745 !important;}
 .pagination-sm .page-link{
 	padding: 5px 12px !important;
 	margin-top: 40px;
 	}	
 .page-link:focus{box-shadow: none !important;}	
</style>



// WEBPACK FOOTER //
// src/view/booking/booking-list.vue